var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-bg-red-400 tw-flex tw-border-red-200tw-border tw-border-solid tw-border-2 tw-rounded-full border-color-blink",style:({
    width: (_vm.diameter + "px"),
    height: (_vm.diameter + "px")
  }),attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }